import axios from '@/lib/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateAddressPayload {
  address: string;
  zipcode: string;
  city: string;
  state: string;
  country: string;
  default_address: boolean;
  address_name: string;
  bedroom: number;
  bathroom: number;
  people: number;
  pet: number;
  cleaning_area: string;
  house_desc: string;
  latitude: number;
  longitude: number;
}

interface UpdateAddressParams {
  addressId: string;
  payload: UpdateAddressPayload;
}

const putUsersAddressesMutation = async ({
  addressId,
  payload,
}: UpdateAddressParams) => {
  const response = await axios.put(`/users/addresses/${addressId}`, payload);
  return response;
};

export const usePutUsersAddressesMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['put-users-addresses'],
    mutationFn: putUsersAddressesMutation,
    onSuccess: () => {
      // Address book reads from ['user', 'details', userid]; prefix-match
      // invalidates all user-detail caches since userid is not available here.
      void queryClient.invalidateQueries({
        queryKey: ['user', 'details'],
        exact: false,
      });
    },
  });
};
